export function socialSticky() {
    const $window = window;
    const $header = document.querySelector(".header");
    const $articleHolder = document.querySelector(".article-section");
    const $socialParent = document.querySelector(".featured-image-holder");
    const $social = $socialParent.querySelector(".social-list");
    let headerHeight;
    let windowHeight;
    let socialHeight;
    let articleHolderHeight;
    let socialParentTop;
    let articleHolderTop;

    function stickyHeaderOnScroll() {
        windowHeight = $window.innerHeight;
        headerHeight = $header.clientHeight;
        articleHolderHeight = $articleHolder.clientHeight;
        socialHeight = $social.clientHeight;
        socialParentTop = $socialParent.offsetTop;
        articleHolderTop = $articleHolder.offsetTop;
        if (window.scrollY + headerHeight + 10 > socialParentTop && window.scrollY + 10 < (articleHolderTop - socialParentTop) + articleHolderHeight + socialHeight) {
            $social.removeAttribute("style");
            $social.classList.add("sticky");
            $social.classList.remove("bottom");
        }
        if (window.scrollY + headerHeight + 10 < socialParentTop) {
            $social.classList.remove("sticky");
        }
        if (window.scrollY + 10 > (articleHolderTop - socialParentTop) + articleHolderHeight + socialHeight) {
            $social.classList.add("bottom");
            $social.classList.remove("sticky");
            $social.style.top = (articleHolderTop - socialParentTop) + articleHolderHeight - socialHeight + "px";
        }
    }


    window.addEventListener("load", () => {
        stickyHeaderOnScroll();
    });

    window.addEventListener("scroll", stickyHeaderOnScroll);

}


// WEBPACK FOOTER //
// ./assets/js/modules/socialSticky.js